
import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from '../services/Common/configuration.service';
import { NotificationService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class MasterdataEndpoint extends EndpointFactory {
  private readonly _getTenantsUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Shared/gettenants`;
  private readonly _getHealthTenantsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Shared/gettenants`;
  private readonly _getLifeTenantsUrl: string = `${this.configurations.baseUrl}${this.configurations.lifeSuffix}/api/life/Shared/gettenants`;
  private readonly _getLoginProvidersUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Shared/getloginproviders`;
  private readonly _getbusinessentitiesbytenantUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Shared/getbusinessentitiesbytenant`;
  private readonly _getUpdateSurveyChildQuestionsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Shared/getUpdateSurveyChildQuestions`;
  private readonly _getUserAuthorityUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Shared/getuserauthority`;
  private readonly _copyUserAuthorityUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Shared/copyuserauthority`;
  private readonly _getUserTenantsUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Shared/getusertenants`;
  private readonly _updateUserAuthorityUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Shared/updateuserauthority`;
  private readonly _getCopyUserAuthorityUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Shared/getcopyfromusers`;
  private readonly _getTobSSUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Shared/gettobss`;
  private readonly _getMemberRelationsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Shared/getMemberRelations`;
  private readonly _getMaritalStatusUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Shared/getMaritalStatus`;
  private readonly _getCountryUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Shared/getcountrylist`;  
  private readonly _getSurveyQuestionsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Shared/getSurveyQuestions`;
  private readonly _getUWDecisionStatusUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Shared/getUWDecisionStatus`;
  private readonly _getUWActionUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Shared/getUWAction`;

  private readonly _getHealthbusinessentitiesbytenantUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Shared/getbusinessentitiesbytenantanduserType`;
  private readonly _getLifebusinessentitiesbytenantUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/life/Shared/getbusinessentitiesbytenantanduserType`;

  private readonly _getAllRolesUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Shared/getAllRoles`;
  private readonly _getNextApproversByUserTypeUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/idp/Shared/getNextApproversByUserType`;
  private readonly _getPermissionsLookupUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/idp/Shared/getPermissionsLookup`;
  private readonly _gettenantsbyserviceUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/idp/Shared/gettenantsbyservice`;

  // tslint:disable-next-line: max-line-length
  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector, private notificationService: NotificationService) {
    super(http, configurations, injector);
  }

  getTenantsEndpoint<T>(): Observable<T> {
    const endpointUrl = `${this._getTenantsUrl}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getTenantsEndpoint());
      }));
  }

  getHealthTenantsEndpoint<T>(): Observable<T> {
    const endpointUrl = `${this._getHealthTenantsUrl}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getHealthTenantsEndpoint());
      }));
  }
  getLifeTenantsEndpoint<T>(): Observable<T> {
    const endpointUrl = `${this._getLifeTenantsUrl}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getLifeTenantsEndpoint());
      }));
  }


  getAllRolesEndPoint<T>(): Observable<T> {
    const endpointUrl = `${this._getAllRolesUrl}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getAllRolesEndPoint());
      }));
  }
  getLoginProvidersEndpoint<T>(): Observable<T> {
    const endpointUrl = `${this._getLoginProvidersUrl}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getLoginProvidersEndpoint());
      }));
  }

  getBusinessEntitiesByTenantEndpoint<T>(tenantId: number): Observable<any> {
    const endpointUrl = `${this._getbusinessentitiesbytenantUrl}/${tenantId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getBusinessEntitiesByTenantEndpoint(tenantId));
      }));
  }
  getHealthBusinessEntitiesByTenantUserType<T>(tenantId: number, userTypeId: number): Observable<any> {
    const endpointUrl = `${this._getHealthbusinessentitiesbytenantUrl}/${tenantId}/${userTypeId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getHealthBusinessEntitiesByTenantUserType(tenantId, userTypeId));
      }));
  }
  getNextApproversByUserType<T>(serviceId: number): Observable<any> {
    const endpointUrl = `${this._getNextApproversByUserTypeUrl}/${serviceId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getNextApproversByUserType(serviceId));
      }));
  }

  getPermissionsLookup<T>(serviceId: number, productId: number): Observable<any> {
    const endpointUrl = `${this._getPermissionsLookupUrl}/${serviceId}/${productId}`;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getPermissionsLookup(serviceId, productId));
      }));
  }
  gettenantsbyservice<T>(serviceId: number): Observable<any> {
    const endpointUrl = `${this._gettenantsbyserviceUrl}/${serviceId}`;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.gettenantsbyservice(serviceId));
      }));
  }



  getLifeBusinessEntitiesByTenantUserType<T>(tenantId: number, userTypeId: number): Observable<any> {
    const endpointUrl = `${this._getLifebusinessentitiesbytenantUrl}/${tenantId}/${userTypeId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getLifeBusinessEntitiesByTenantUserType(tenantId, userTypeId));
      }));
  }

  getUserAuthorityEndPoint<T>(userId: string): Observable<any> {
    const endpointUrl = `${this._getUserAuthorityUrl}/${userId}`;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<boolean>(
      catchError(error => {
        return this.handleError(error, () => this.getUserAuthorityEndPoint(userId));
      }));
  }
  getUSerTenantsEndpoint<T>(): Observable<T> {
    const endpointUrl = `${this._getUserTenantsUrl}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getUSerTenantsEndpoint());
      }));
  }
  getCopyFromUsersEndPoint<T>(userId: string): Observable<any> {
    const endpointUrl = `${this._getCopyUserAuthorityUrl}/${userId}`;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<boolean>(
      catchError(error => {
        return this.handleError(error, () => this.getCopyFromUsersEndPoint(userId));
      }));
  }

  UpdateUserAuthorityEndpoint<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this._updateUserAuthorityUrl}`;

    return this.http.put<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.UpdateUserAuthorityEndpoint(userObject));
      }));
  }

  copyUserAuthorityEndPoint<T>(fromUserId: string, toUserId: string): Observable<boolean> {
    const endpointUrl = `${this._copyUserAuthorityUrl}/${fromUserId}/${toUserId}`;
    return this.http.post<T>(endpointUrl, this.getRequestHeaders()).pipe<boolean>(
      catchError(error => {
        return this.handleError(error, () => this.copyUserAuthorityEndPoint(fromUserId, toUserId));
      }));
  }

  getMemberRelations<T>(): Observable<any> {
    const endpointUrl = `${this._getMemberRelationsUrl}`;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<boolean>(
      catchError(error => {
        return this.handleError(error, () => this.getMemberRelations());
      }));
  }

  getMaritalStatus<T>(): Observable<any> {
    const endpointUrl = `${this._getMaritalStatusUrl}`;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<boolean>(
      catchError(error => {
        return this.handleError(error, () => this.getMaritalStatus());
      }));
  }
  getCountry<T>(): Observable<any> {
    const endpointUrl = `${this._getCountryUrl}`;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<boolean>(
      catchError(error => {
        return this.handleError(error, () => this.getCountry());
      }));
  }
  getSurveyQuestions<T>(quotationId, surveyName): Observable<any> {
    const endpointUrl = `${this._getSurveyQuestionsUrl}/${quotationId}/${surveyName}`;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<boolean>(
      catchError(error => {
        return this.handleError(error, () => this.getSurveyQuestions<T>(quotationId, surveyName));
      }));
  }


  getUpdateSurveyChildQuestions<T>(mafSurveyAnswersRequest: any): Observable<any> {
    const endpointUrl = `${this._getUpdateSurveyChildQuestionsUrl}`;
    return this.http.post(endpointUrl, JSON.stringify(mafSurveyAnswersRequest), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUpdateSurveyChildQuestions(mafSurveyAnswersRequest));
      }));
  }



  getUWDecisionStatus<T>(): Observable<any> {
    const endpointUrl = `${this._getUWDecisionStatusUrl}`;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<boolean>(
      catchError(error => {
        return this.handleError(error, () => this.getUWDecisionStatus<T>());
      }));
  }
  getUWAction<T>(): Observable<any> {
    const endpointUrl = `${this._getUWActionUrl}`;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<boolean>(
      catchError(error => {
        return this.handleError(error, () => this.getUWAction<T>());
      }));
  }
  getTOBSuperScripts<T>(): Observable<any> {
    const endpointUrl = `${this._getTobSSUrl}`;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<boolean>(
      catchError(error => {
        return this.handleError(error, () => this.getTOBSuperScripts());
      }));
  }
}
